import { useState } from 'react';
import { Info, Flame, Zap, Utensils, ChevronDown } from 'lucide-react';
import * as S from './styles';

// Custom Running Person Icon
const RunningPerson = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M13 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" />
    <path d="M4 17l5 1l.75 -1.5" />
    <path d="M15 21l0 -4l-4 -3l1 -6" />
    <path d="M7 12l0 -3l5 -1l3 3l3 1" />
  </svg>
);

export const NutritionalInfo = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <S.Container>
      <S.Header onClick={() => setIsExpanded(!isExpanded)}>
        <S.Title>معلومات غذائية</S.Title>
        <S.ToggleIcon $isExpanded={isExpanded}>
          <ChevronDown size={20} />
        </S.ToggleIcon>
      </S.Header>
      <S.Content $isExpanded={isExpanded}>
        <S.List>
        <S.ListItem>
          <S.IconWrapper>
            <Info size={20} />
          </S.IconWrapper>
          <span>
            العناصر في هذه القائمة قد تحتوي على جميع المواد المسببة للحساسية أو أي منها.
          </span>
        </S.ListItem>

        <S.ListItem>
          <S.IconWrapper>
            <Flame size={20} />
          </S.IconWrapper>
          <span>
            يحتاج البالغون إلى متوسط 2000 سعرة حرارية في اليوم، وتختلف احتياجات السعرات من شخص لآخر. يحتاج الأطفال من عمر 4 إلى 13 عامًا إلى متوسط 1200-1500 سعرة حرارية في اليوم، وتختلف احتياجاتهم أيضًا.
          </span>
        </S.ListItem>

        <S.ListItem>
          <S.IconWrapper>
            <Zap size={20} />
          </S.IconWrapper>
          <span>
            يشير هذا الملصق إلى كمية الكافيين بالمليغرام/الكوب. لا ينبغي أن يتجاوز استهلاك الكافيين للبالغين 400 ملغ.
          </span>
        </S.ListItem>

        <S.ListItem>
          <S.IconWrapper>
            <Utensils size={20} />
          </S.IconWrapper>
          <span>
            يشير هذا الملصق إلى أن العنصر الغذائي يحتوي على كمية مرتفعة من الملح مقارنة بالكمية الموصى بها يوميًا. لا ينبغي أن يتجاوز استهلاك الفرد من الملح 5 غرامات يوميًا، أي ما يعادل 2000 ملليغرام من الصوديوم.
          </span>
        </S.ListItem>

        <S.ListItem>
          <S.IconWrapper>
            <RunningPerson size={20} />
          </S.IconWrapper>
          <span>
            يشير هذا الملصق إلى الوقت المقدر اللازم لحرق السعرات الحرارية لهذا العنصر.
          </span>
        </S.ListItem>
        </S.List>
      </S.Content>
    </S.Container>
  );
};
